import { Download } from 'lucide-react';

import { Button } from '../../../../components/ui/button';
import type { Project } from '../../model/project';

interface MultimediaHeaderProps {
  isDownloading: boolean;
  onDownloadAll: () => void;
  project: Project;
  totalFiles: number;
}

const MultimediaHeader = ({ isDownloading, onDownloadAll, project, totalFiles }: MultimediaHeaderProps) => (
  <header className="flex flex-col gap-4 border-b border-border-subtle pb-5 md:flex-row md:items-start md:justify-between">
    <div className="flex min-w-0 flex-col gap-2">
      <p className="font-body text-xs font-bold uppercase tracking-widest text-text-subtle">
        {`${project.masterProjectId === null ? 'Inmobiliaria' : 'Subproyecto'} #${project.id}`}
      </p>
      <div className="flex flex-wrap items-center gap-2">
        {project.masterProject?.name && (
          <>
            <h1 className="m-0 font-display text-2xl font-extrabold text-brand-navy">{project.masterProject.name}</h1>
            <span className="text-xl text-text-muted">/</span>
          </>
        )}
        <h2 className="m-0 font-display text-xl font-bold text-text-default">{project.name}</h2>
      </div>
    </div>
    <Button
      className="w-fit shrink-0 bg-brand-vivid text-white hover:bg-brand-sky-dark"
      disabled={isDownloading || totalFiles === 0}
      onClick={onDownloadAll}
      type="button"
    >
      <Download className="size-4" />
      {isDownloading ? 'Descargando...' : `Descargar todo (${totalFiles})`}
    </Button>
  </header>
);

export default MultimediaHeader;
